import React from 'react'
import { FiDownload } from 'react-icons/fi';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';

const TabForInterFirm = ({ ewayBillChecker, tabList, callBackTab, activeTab, arrowIcon = false, invoiceBillRaiseClass, disabled = false, isCountShow = false, isActiveButton = false, isActiveExport = false, rightButton, tabButtonName, section = "", showAmount = false, keyStatusInsideTabs = false, buttonTitle = "", exportButton = () => { } }) => {

    const navigate = useNavigate();

    const changeActiveTab = async (event, value) => {
        event.preventDefault();
        callBackTab(value);
    };

    return (
        <>
            <ul className={`nav nav-tabs cstNew_tabs ${invoiceBillRaiseClass}`} id="addParty" role="tablist">
                {tabList?.map((item, indx) => {
                
                    const key = indx + (item?.title || item?.name);
                    const isActive = activeTab?._id === item?._id;

                    return (
                        <li
                            className="nav-item _vhlTab_li"
                            role="presentation"
                            key={key}
                        >
                            <button
                                className={`nav-link tabCst_btn _vhlTab_lst ${isActive ? "active" : ""}`}
                                onClick={(e) => changeActiveTab(e, item)}
                                disabled={disabled}
                            >
                                <span>{item?.name}</span>
                                {isCountShow && (
                                    <div className="_nwRate">
                                        {item?.data != null ? item.data.toFixed(2) : 0}
                                    </div>
                                )}
                                {arrowIcon && (
                                    <div>
                                        <IoChevronForwardOutline />
                                    </div>
                                )}
                            </button>
                        </li>
                    );
                })}

               { (isActiveExport || isActiveButton) && <div className='_rSideBtn' style={{ marginLeft: 'auto' }}>
                    {isActiveExport ?
                        <button className='anime-btn __exptBtn' style={{marginRight:'8px'}} onClick={(e) => exportButton(e)}>  <FiDownload /> {buttonTitle}</button>
                        : <></>}
                    {isActiveButton ? <button className='_addComm_btn' onClick={(e) => rightButton(e)}> {tabButtonName}</button> : <></>}
                </div>}

            </ul>
        </>
    )
}

export default TabForInterFirm